import {
    CLEAR_RESTAURANT_SETTINGS,
    LOAD_RESTAURANT_SETTINGS_SUCCESS,
    UPDATE_RESTAURANT_SETTINGS_SUCCESS
} from '../../../../actions/types';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_RESTAURANT_SETTINGS_SUCCESS:
            return action.payload;
        case UPDATE_RESTAURANT_SETTINGS_SUCCESS:
            return action.payload;
        case CLEAR_RESTAURANT_SETTINGS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/GeneralServicesReducer.js